/* eslint-disable no-use-before-define, eqeqeq */
import React from 'react'
import { fmt } from '../../twd'

export const Summary = ({context}) => {
    const n = context.filterByDate
    

    return <React.Fragment>
        <div className="row">
        <h4 className="col-md-12 text-medium">Trade summary for {n == 0 ? 'today' : `last ${n} days`} </h4>
        </div>

        <div className="row vertical-offset-sm"            
            style={{
                margin: 0,
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingLeft: '5px',
                backgroundColor:"rgb(246, 246, 246)"                
            }}>
        <div className="col-md-6 col-xs-6"><Col title="Highest trade price" {...context.highestTrade} /></div>
        <div className="col-md-6 col-xs-6"><Col title="Lowest trade price" {...context.lowestTrade} /></div>
        </div>        
    </React.Fragment>
}

const Col = ({title, tradePrice, tradeYield, tradeDate} = {}) => {
    return <React.Fragment>
        <h5 className="vertical-offset-xs summary-trade-title">{title}</h5>

        <dl className="summary-trade-dl">
            <div>
                <dt>Price</dt>
                <dd className="text-medium">{fmt.price3(tradePrice)}</dd>
            </div>
            <div>
                <dt>Yield</dt>
                <dd className="text-medium">{fmt.ytw3(tradeYield)}</dd>
            </div>
            <div>
                <dt>Date</dt>
                <dd className="text-medium">{tradeDate}</dd>
            </div>
        </dl>

        <div className="xs-show text-medium">
            {fmt.price3(tradePrice)}/{fmt.ytw3(tradeYield)}
            <br/>
            {tradeDate}
        </div>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/trade-history/summary-table/summary.js